import React from "react";
import { Link } from "react-router-dom";
import { usePageSeo } from "@/lib/usePageSeo";

// Catch-all 404. Under the current static-SPA hosting every unknown URL
// returns HTTP 200 with the app shell — true 404 STATUS requires server
// control we don't have (see SEO Phase 1 report). This page is the
// CSR-correct mitigation: rendered <meta robots noindex> keeps arbitrary
// URLs out of the index and gives real users a way back.
export default function NotFoundPage() {
  usePageSeo({
    title: "Page Not Found — Ur Designs",
    description: "This page doesn't exist. Explore Ur Designs branding, print, digital, packaging and 3D creative services.",
    noindex: true,
  });
  return (
    <div data-testid="not-found-page" className="bg-[#0F0F0F] min-h-[70vh] flex items-center">
      <div className="max-w-2xl mx-auto px-6 py-24 text-center">
        <p className="font-display text-sm font-bold uppercase tracking-[0.3em] text-[#FF6600]">404</p>
        <h1 className="mt-4 font-display text-4xl sm:text-5xl font-bold text-white">
          This page doesn&rsquo;t exist.
        </h1>
        <p className="mt-4 text-base text-[#A3A3A3]">
          The link may be outdated or the URL may have a typo. Everything we do lives here:
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/"
            data-testid="not-found-home-link"
            className="rounded-full bg-[#FF6600] px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-[#e55c00]"
          >
            Back to Homepage
          </Link>
          <Link
            to="/services"
            data-testid="not-found-services-link"
            className="rounded-full border border-white/20 px-6 py-3 text-sm font-semibold text-white transition-colors hover:border-[#FF6600] hover:text-[#FF6600]"
          >
            Explore Services
          </Link>
        </div>
      </div>
    </div>
  );
}
